var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["o-width-limiter o-width-limiter--main", _vm.className] },
    [
      _c(
        "div",
        {
          class: [
            {
              "c-info-block--image-left": _vm.imageAlignment === "left"
            },
            {
              "c-info-block--image-right": _vm.imageAlignment === "right"
            },
            "o-grid",
            "c-info-block"
          ]
        },
        [
          _c(
            "div",
            {
              staticClass: "o-grid__column",
              attrs: { "data-size": "md:12 lg:9" }
            },
            [
              _c(
                "div",
                {
                  class: [
                    "c-info-block__content",
                    _vm.color === "orange" && "c-info-block--orange",
                    _vm.color === "pink" && "c-info-block--pink",
                    _vm.color === "blue" && "c-info-block--blue",
                    _vm.color === "green" && "c-info-block--green"
                  ]
                },
                [
                  _c("div", { staticClass: "c-info-block__content-wrapper" }, [
                    _c(
                      "h2",
                      { staticClass: "c-info-block__heading heading-boarder" },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.heading) +
                            "\n\t\t\t\t\t"
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.text
                      ? _c("p", { staticClass: "c-info-block__text" }, [
                          _vm._v(_vm._s(_vm.text))
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.url && _vm.buttonText
                      ? _c(
                          "a",
                          {
                            staticClass: "c-info-block__link",
                            attrs: { href: _vm.url }
                          },
                          [
                            _c("span", [_vm._v(_vm._s(_vm.buttonText))]),
                            _vm._v(" "),
                            _c("v-icon", {
                              attrs: {
                                name: _vm.getIcon(_vm.url),
                                size: "xxs",
                                cssModifiers: "c-info-block__icon"
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("img", {
            staticClass: "c-info-block__image",
            attrs: { src: _vm.src, alt: _vm.alt || "" }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }